/* Eigene Produktoptionen statt Globo (Roadmap 3.2, seit Paket C live).
 *
 * Dieses Skript hat nur etwas zu tun, wenn snippets/mhsys-produktoptionen.liquid ueberhaupt
 * eine .mhsys-po-Box gerendert hat - das haengt allein am Theme-Schalter
 * "Eigene Produktoptionen statt Globo" (settings.mhsys_produktoptionen_eigen). Fuer jeden
 * Seitenaufruf ohne das Metafeld findet querySelectorAll unten nichts und das Skript tut nichts.
 *
 * Zwei faellige Aufgaben, bevor ein Formular mit Produktoptionen abgeschickt wird:
 * 1. Zeichenregel pruefen (Portierung von produktoptionen_zeichen_erlaubt() in
 *    mhsystem system/core/produktoptionen.inc.php - dieselbe Zeichenklasse. ACHTUNG: die kurze
 *    Schreibweise \p{Latin} ist zwar AUSSERHALB einer Zeichenklasse gueltig
 *    (/\p{Latin}/u), aber INNERHALB einer Zeichenklasse [...] verlangt Chrome die volle Form
 *    \p{Script=Latin} - \p{Latin} dort wirft "Invalid property name in character class" und
 *    laesst die GANZE Datei nicht mehr parsen (SyntaxError bei der Regex-Literal-Auswertung,
 *    nicht nur diese eine Zeile). Live entdeckt beim Umschalten auf Paket C, 21.09.2026 -
 *    production.inc.php/PHP kennt diese Falle nicht, PCRE ist da grosszuegiger.
 * 2. Genitiv-Frage stellen, wenn das Feld ein Druckmuster mit {name}s traegt und die
 *    beiden Fassungen (mit/ohne Apostroph-s) tatsaechlich verschieden sind - Portierung von
 *    produktoptionen_genitiv_fassungen()/produktion_wunschtext_bauen(). Antwort "nein" geht
 *    als properties[_genitiv]=nein mit (Vertrag: core/orders_import.inc.php liest genau
 *    diesen einen Schluessel, "ja" oder ein fehlender Wert aendert am Druck nichts).
 *
 * Felder mit Aufpreis (feld.aufpreis bzw. wert.preis > 0) sind bei Shopify eine eigene
 * Variante - die kann kein properties[...]-Feld abbilden, das braucht eine zweite
 * Warenkorbzeile. Dafuer wird bei Bedarf komplett selbst an /cart/add.js gepostet (JSON-Body
 * mit items[], wie im Aufpreis-Fall bei Globo ueblich), mit derselben Gruppierung
 * (_gpo_product_group / _gpo_parent_product_group), die mhsys-warenkorb.js beim Mengen-
 * Abgleich (globoAngleichen) schon versteht - keine neue Konvention. Ohne Aufpreis bleibt
 * die Zeile aus properties[...]-Feldern im normalen Formular stehen und
 * mhsys-kaufformular.js schickt sie wie jedes andere Kaufformular ab; dieses Skript greift
 * dann nur validierend ein (preventDefault bei einem Zeichenfehler oder einer offenen
 * Genitiv-Frage), nie sonst.
 */
(() => {
  'use strict';

  // Woertlich dieselbe Zeichenklasse wie produktoptionen_zeichen_erlaubt() in
  // mhsystem system/core/produktoptionen.inc.php.
  const ZEICHEN_ERLAUBT = /^[\p{Script=Latin}0-9\s.,\-'’!?&+/():;"„“@#€%]*$/u;
  const ZEICHEN_VERBOTEN = /[^\p{Script=Latin}0-9\s.,\-'’!?&+/():;"„“@#€%]/gu;

  function zeichenErlaubt(text) {
    return ZEICHEN_ERLAUBT.test(text);
  }

  function zeichenVerboten(text) {
    if (zeichenErlaubt(text)) return '';
    const treffer = text.match(ZEICHEN_VERBOTEN) || [];
    return [...new Set(treffer)].slice(0, 5).join('');
  }

  /* Die Meldung am Feld auch für Screenreader (Rundum-Check 30.10.2026): die Eingaben der Box bekommen aria-invalid und
     verweisen per aria-describedby auf die Meldung; die Meldung selbst ist eine Live-Region (snippets/mhsys-produktoptionen.liquid) */
  let fehlerZaehler = 0;
  function fehlerAnsagen(feldBox, fehler) {
    const fehlerEl = feldBox.querySelector('[data-mhsys-po-fehler]');
    if (fehlerEl && !fehlerEl.id) fehlerEl.id = `mhsys-po-fehler-${++fehlerZaehler}`;
    feldBox.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach((el) => {
      if (fehler) {
        el.setAttribute('aria-invalid', 'true');
        if (fehlerEl) el.setAttribute('aria-describedby', fehlerEl.id);
      } else {
        el.removeAttribute('aria-invalid');
        if (fehlerEl && el.getAttribute('aria-describedby') === fehlerEl.id) el.removeAttribute('aria-describedby');
      }
    });
  }

  // Portierung von produktion_wunschtext_bauen() aus mhsystem system/core/produktion.inc.php -
  // dieselbe Fallunterscheidung (Apostroph am Ende: das Muster-s faellt weg; s/ß/x/z am Ende:
  // Apostroph statt "s"), damit die Vorschau hier zu dem passt, was core/orders_import.inc.php
  // spaeter tatsaechlich druckt.
  function wunschtextBauen(text, muster) {
    text = (text || '').trim();
    muster = (muster || '').trim();
    if (text === '' || muster === '' || !muster.includes('{name}')) return text;

    const idx = muster.indexOf('{name}');
    const vorne = muster.slice(0, idx);
    let hinten = muster.slice(idx + '{name}'.length);

    if (hinten.startsWith('s')) {
      const endetApostroph = /['’´`]s?$/u.test(text);
      const endetSlaut = /[sßxzSXZ]$/u.test(text);
      if (endetApostroph) {
        hinten = hinten.slice(1);
      } else if (endetSlaut) {
        hinten = '’' + hinten.slice(1);
      }
    }

    return vorne + text + hinten;
  }

  // Portierung von produktoptionen_genitiv_fassungen().
  function genitivFassungen(text, muster) {
    text = (text || '').trim();
    muster = (muster || '').trim();
    const mit = wunschtextBauen(text, muster);

    const pos = muster.indexOf('{name}');
    if (pos === -1) return { mit, ohne: mit, unterschiedlich: false };

    const abPlatzhalter = pos + '{name}'.length;
    const hinten = muster.slice(abPlatzhalter);
    if (!hinten.startsWith('s')) return { mit, ohne: mit, unterschiedlich: false };

    const musterOhne = muster.slice(0, abPlatzhalter) + hinten.slice(1);
    const ohne = wunschtextBauen(text, musterOhne);

    return { mit, ohne, unterschiedlich: mit !== ohne };
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  class MhsysProduktoptionenController {
    constructor(box) {
      this.box = box;
      this.formular = box.closest('form');
      this.laeuft = false;
      this.genitivFeldSchluessel = null; // erstes Feld mit genitiv_muster
      this.genitivWert = null; // 'ja' | 'nein' | null (noch nicht entschieden)

      let daten;
      try {
        daten = JSON.parse(box.dataset.mhsysPoDaten || '{}');
      } catch (fehler) {
        daten = { felder: [] };
      }
      this.felder = Array.isArray(daten.felder) ? daten.felder : [];

      const genitivFeld = this.felder.find((f) => f.genitiv_muster);
      if (genitivFeld) this.genitivFeldSchluessel = genitivFeld.schluessel;

      if (!this.formular || !this.felder.length) return;

      this.box.addEventListener('input', (e) => this.beiEingabe(e));
      // WICHTIG: nicht am Formular selbst registrieren. Fuer ein Ereignis, das direkt am
      // Formular ausgeloest wird, zaehlt am Ziel selbst nur die Reihenfolge der Registrierung,
      // nicht das capture-Flag (DOM-Spezifikation, AT_TARGET-Phase) - mhsys-kaufformular.js
      // haengt seinen submit-Listener schon beim Parsen an (Script im Layout, vor dieser
      // Sektion), ein zweiter Listener direkt am Formular liefe also IMMER hinterher. Am
      // umschliessenden <mhsys-kaufformular> registriert, laeuft die Capture-Phase (Vorfahre)
      // garantiert vor der Zielphase (Formular selbst) ab - so kommt diese Pruefung zuerst.
      this.formular.parentElement.addEventListener('submit', (e) => this.beiAbsenden(e), true);
    }

    feldBox(schluessel) {
      return this.box.querySelector(`[data-mhsys-po-feld="${CSS.escape(schluessel)}"]`);
    }

    beiEingabe(e) {
      const feldBox = e.target.closest('[data-mhsys-po-feld]');
      if (!feldBox) return;
      const schluessel = feldBox.dataset.mhsysPoFeld;
      if (schluessel === this.genitivFeldSchluessel) {
        this.genitivWert = null;
        this.genitivBoxEntfernen();
      }
      const feld = this.felder.find((f) => f.schluessel === schluessel);
      if (feld && feld.typ !== 'text' && feld.typ !== 'textarea') {
        /* Auswahl getroffen: eine Pflicht-Meldung von vorhin verschwindet */
        feldBox.classList.remove('mhsys-po__feld--fehler');
        const fehlerEl = feldBox.querySelector('[data-mhsys-po-fehler]');
        if (fehlerEl) { fehlerEl.textContent = ''; fehlerEl.hidden = true; }
        fehlerAnsagen(feldBox, false);
        return;
      }
      if (!feld) return;
      this.zeichenPruefen(feldBox, e.target.value);
    }

    zeichenPruefen(feldBox, wert) {
      const fehlerEl = feldBox.querySelector('[data-mhsys-po-fehler]');
      const verboten = zeichenVerboten(wert || '');
      if (verboten) {
        feldBox.classList.add('mhsys-po__feld--fehler');
        if (fehlerEl) {
          fehlerEl.textContent = `Diese Zeichen gehen leider nicht: ${verboten}`;
          fehlerEl.hidden = false;
        }
        fehlerAnsagen(feldBox, true);
        return false;
      }
      feldBox.classList.remove('mhsys-po__feld--fehler');
      if (fehlerEl) {
        fehlerEl.textContent = '';
        fehlerEl.hidden = true;
      }
      fehlerAnsagen(feldBox, false);
      return true;
    }

    /* Pflichtfeld leer: Meldung am Feld. Das Formular ist novalidate (eigene Pruefung statt der
       Browser-Blase) - bis 21.09.2026 prueften wir hier nur verbotene Zeichen, nie die Pflicht, und ein
       Wunschname-Krug ging mit leerem Wunschtext in den Warenkorb (Gegentest Roadmap 3.25). */
    pflichtFehler(feldBox, meldung) {
      const fehlerEl = feldBox.querySelector('[data-mhsys-po-fehler]');
      feldBox.classList.add('mhsys-po__feld--fehler');
      if (fehlerEl) {
        fehlerEl.textContent = meldung;
        fehlerEl.hidden = false;
      }
      fehlerAnsagen(feldBox, true);
    }

    alleGueltig() {
      let gueltig = true;
      let ersteFehlerhafteEingabe = null;
      const merken = (el) => {
        gueltig = false;
        if (!ersteFehlerhafteEingabe) ersteFehlerhafteEingabe = el;
      };
      for (const feld of this.felder) {
        const feldBox = this.feldBox(feld.schluessel);
        if (!feldBox) continue;
        if (feld.typ === 'text' || feld.typ === 'textarea') {
          const eingabe = feldBox.querySelector('.mhsys-po__eingabe');
          if (!eingabe) continue;
          if (!this.zeichenPruefen(feldBox, eingabe.value)) {
            merken(eingabe);
          } else if (feld.pflicht && eingabe.value.trim() === '') {
            this.pflichtFehler(feldBox, 'Bitte ausfüllen.');
            merken(eingabe);
          }
          continue;
        }
        if (!feld.pflicht) continue;
        /* Auswahl: leere Option / kein Radiopunkt. Die "feste Wahl" (verstecktes Feld) hat immer einen Wert */
        const auswahl = feldBox.querySelector('select.mhsys-po__eingabe');
        const radios = [...feldBox.querySelectorAll('input[type="radio"]')];
        const leer = auswahl ? auswahl.value === '' : radios.length > 0 && !radios.some((r) => r.checked);
        if (leer) {
          this.pflichtFehler(feldBox, 'Bitte auswählen.');
          merken(auswahl || radios[0]);
        } else {
          feldBox.classList.remove('mhsys-po__feld--fehler');
          const fehlerEl = feldBox.querySelector('[data-mhsys-po-fehler]');
          if (fehlerEl) { fehlerEl.textContent = ''; fehlerEl.hidden = true; }
        }
      }
      if (ersteFehlerhafteEingabe) ersteFehlerhafteEingabe.focus();
      return gueltig;
    }

    // Das eine Feld mit Genitiv-Muster: noch keine Entscheidung, Wert nicht leer, und die
    // beiden Fassungen unterscheiden sich tatsaechlich (sonst gaebe es nichts zu fragen).
    offeneGenitivFrage() {
      if (!this.genitivFeldSchluessel || this.genitivWert !== null) return null;
      const feld = this.felder.find((f) => f.schluessel === this.genitivFeldSchluessel);
      const feldBox = this.feldBox(this.genitivFeldSchluessel);
      const eingabe = feldBox && feldBox.querySelector('.mhsys-po__eingabe');
      if (!feld || !feldBox || !eingabe) return null;
      const wert = eingabe.value.trim();
      if (wert === '') return null;
      const fassungen = genitivFassungen(wert, feld.genitiv_muster);
      if (!fassungen.unterschiedlich) return null;
      return { feld, feldBox, fassungen };
    }

    genitivBoxEntfernen() {
      const vorhanden = this.box.querySelector('.mhsys-po__genitiv');
      if (vorhanden) vorhanden.remove();
    }

    genitivBoxZeigen({ feldBox, fassungen }) {
      this.genitivBoxEntfernen();
      const box = document.createElement('div');
      box.className = 'mhsys-po__genitiv';
      box.innerHTML = `
        <p class="mhsys-po__genitiv-frage">Wie soll es produziert werden?</p>
        <label class="mhsys-po__genitiv-wahl">
          <input type="radio" name="mhsys-po-genitiv-wahl" value="ja" checked>
          <span>${escapeHtml(fassungen.mit)}</span>
        </label>
        <label class="mhsys-po__genitiv-wahl">
          <input type="radio" name="mhsys-po-genitiv-wahl" value="nein">
          <span>${escapeHtml(fassungen.ohne)}</span>
        </label>
        <button type="button" class="mhsys-knopf mhsys-po__genitiv-knopf">Weiter</button>
      `;
      // Vorbelegung "ja" (Genitiv-s, der ohnehin automatisch gedruckte Normalfall) ist schon
      // angehakt - nur bei einem Wechsel auf "nein" gibt es etwas zu vermerken.
      this.genitivWert = 'ja';
      box.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          this.genitivWert = radio.value;
        });
      });
      box.querySelector('button').addEventListener('click', () => {
        this.genitivBoxEntfernen();
        if (this.formular.requestSubmit) this.formular.requestSubmit();
        else this.formular.submit();
      });
      feldBox.appendChild(box);
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    genitivHiddenFeldSetzen() {
      if (this.genitivWert === null) return;
      let versteckt = this.formular.querySelector('[data-mhsys-po-genitiv-versteckt]');
      if (!versteckt) {
        versteckt = document.createElement('input');
        versteckt.type = 'hidden';
        versteckt.name = 'properties[_genitiv]';
        versteckt.dataset.mhsysPoGenitivVersteckt = '1';
        this.formular.appendChild(versteckt);
      }
      versteckt.value = this.genitivWert;
    }

    // Felder/Werte mit einem Aufpreis > 0 brauchen bei Shopify eine eigene Warenkorbzeile
    // (eine eigene Variante), properties[...] kann keinen Preis aendern. _gpo_field_name ist
    // Globos eigene Konvention (live gegengeprueft, 21.09.2026: derselbe Schluessel, an Globos
    // Zusatzzeilen dieselbe Eigenschaft) - hier mit uebernommen, falls etwas Bestehendes danach
    // sucht. Globo legt zusaetzlich auch fuer 0,00-Werte eine eigene Zeile an (die Produktzeile
    // selbst als 0-€-Position); das macht dieser Code bewusst nicht - properties[<schluessel>]
    // auf der Hauptzeile sagt bereits, was gewaehlt wurde, eine zusaetzliche Leerzeile waere nur
    // Ballast. Wenn der Inhaber die Optik von Globo (eigene Zeile je Auswahl) will, ist das eine
    // eigene Entscheidung, keine Fehlerkorrektur.
    aufpreisZeilenSammeln() {
      const zeilen = [];
      for (const feld of this.felder) {
        const feldBox = this.feldBox(feld.schluessel);
        if (!feldBox) continue;

        if ((feld.typ === 'text' || feld.typ === 'textarea') && feld.aufpreis) {
          const eingabe = feldBox.querySelector('.mhsys-po__eingabe');
          const preis = parseFloat(feld.aufpreis.preis);
          if (eingabe && eingabe.value.trim() !== '' && feld.aufpreis.variante && preis > 0) {
            zeilen.push({ id: feld.aufpreis.variante, feldname: feld.schluessel, preis });
          }
          continue;
        }

        if (feld.typ === 'select') {
          const auswahl = feldBox.querySelector('.mhsys-po__eingabe');
          const wertDef = (feld.werte || []).find((w) => w.wert === (auswahl && auswahl.value));
          const preis = wertDef && parseFloat(wertDef.preis);
          if (wertDef && wertDef.variante && preis > 0) {
            zeilen.push({ id: wertDef.variante, feldname: feld.schluessel, preis });
          }
          continue;
        }

        if (feld.typ === 'radio' || feld.typ === 'bild') {
          // Feste Wahl (Pflicht-Radio mit genau einer Moeglichkeit, z. B. Einweg-Pfand) steht nur als
          // Textzeile da - ihr Wert liegt im versteckten .mhsys-po__eingabe, nicht in einem Radio
          const gewaehlt = feldBox.querySelector('input[type="radio"]:checked, input[type="hidden"].mhsys-po__eingabe');
          const wertDef = (feld.werte || []).find((w) => w.wert === (gewaehlt && gewaehlt.value));
          const preis = wertDef && parseFloat(wertDef.preis);
          if (wertDef && wertDef.variante && preis > 0) {
            zeilen.push({ id: wertDef.variante, feldname: feld.schluessel, preis });
          }
        }
      }
      return zeilen;
    }

    beiAbsenden(e) {
      if (!this.alleGueltig()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      const offen = this.offeneGenitivFrage();
      if (offen) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.genitivBoxZeigen(offen);
        return;
      }

      this.genitivHiddenFeldSetzen();

      const aufpreisZeilen = this.aufpreisZeilenSammeln();
      // Geschenkbox-Baukasten (sections/mhsys-boxoption.liquid): nur pruefen und melden, was hinein soll - in den Warenkorb legt er die ganze Box
      if (this.formular.hasAttribute('data-mhsys-po-nur-pruefen')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.formular.dispatchEvent(new CustomEvent('mhsys-po:gueltig', {
          detail: { eigenschaften: this.formDatenAlsHauptzeile(new FormData(this.formular)).properties, aufpreis: aufpreisZeilen },
        }));
        return;
      }
      if (aufpreisZeilen.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.mitAufpreisAbsenden(aufpreisZeilen);
      }
      // Sonst: kein Eingriff, mhsys-kaufformular.js uebernimmt das normale Absenden - die
      // hier gesetzten properties[...]-Felder (inkl. properties[_genitiv]) stehen bereits
      // im Formular und werden mit der normalen FormData mitgeschickt.
    }

    formDatenAlsHauptzeile(formDaten) {
      const zeile = { properties: {} };
      for (const [schluessel, wert] of formDaten.entries()) {
        if (schluessel === 'id') zeile.id = wert;
        else if (schluessel === 'quantity') zeile.quantity = wert;
        else {
          const treffer = schluessel.match(/^properties\[(.+)\]$/);
          // Leeres freiwilliges Feld gar nicht erst mitschicken, Rest trimmen - dieselbe Regel
          // wie in assets/mhsys-kaufformular.js, damit beide Wege dasselbe in den Korb legen.
          if (treffer) {
            const sauber = typeof wert === 'string' ? wert.trim() : wert;
            if (sauber !== '') zeile.properties[treffer[1]] = sauber;
          }
        }
      }
      return zeile;
    }

    mitAufpreisAbsenden(aufpreisZeilen) {
      if (this.laeuft) return;
      this.laeuft = true;

      const knopf = this.formular.querySelector('[type="submit"]');
      const meldung = this.formular.querySelector('[data-mhsys-formular-fehler]');
      const fehlerZeigen = (text) => {
        if (!meldung) return;
        meldung.textContent = text || '';
        meldung.hidden = !text;
      };
      fehlerZeigen('');
      if (knopf) {
        knopf.setAttribute('aria-disabled', 'true');
        knopf.classList.add('is-laedt');
      }

      const haupt = this.formDatenAlsHauptzeile(new FormData(this.formular));
      const gruppe = `po-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
      haupt.properties._gpo_product_group = gruppe;

      const items = [haupt];
      aufpreisZeilen.forEach((zeile) => {
        items.push({
          id: zeile.id,
          quantity: haupt.quantity || 1,
          properties: {
            _gpo_parent_product_group: gruppe,
            _gpo_field_name: zeile.feldname,
          },
        });
      });

      const wk = document.querySelector('mhsys-warenkorb');
      const koerper = { items };
      if (wk && wk.sectionName) {
        koerper.sections = wk.sectionName;
        koerper.sections_url = window.location.pathname;
        wk.ausloeserMerken(knopf);
      }
      const url = `${(window.mhsysShop || {}).warenkorbHinzufuegenUrl || '/cart/add'}.js`.replace(/\.js\.js$/, '.js');

      const anfrage = fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          // Dieselbe eigene Kopfzeile wie mhsys-kaufformular.js - mhsys-warenkorb.js
          // erkennt daran den eigenen Aufruf und beobachtet ihn nicht ein zweites Mal.
          'X-Mhsys-Warenkorb': '1',
        },
        body: JSON.stringify(koerper),
      });
      // Danach die Schublade mit Platzhalter, wie beim normalen Kaufformular (Roadmap 1.70) - Bild und Name von dort
      const sofort = wk && typeof wk.einlegenBeginnt === 'function';
      if (sofort) {
        const kf = this.formular.closest('mhsys-kaufformular');
        const menge = Number(haupt.quantity) || 1;
        wk.einlegenBeginnt(kf && kf.platzhalterDaten ? kf.platzhalterDaten(menge) : { menge }, knopf);
      }
      const fehlgeschlagen = (text) => {
        fehlerZeigen(text);
        if (sofort) wk.einlegenFehlgeschlagen(text);
        else if (wk) wk.nurNeuLaden();
      };

      anfrage
        .then((r) => r.json())
        .then((antwort) => {
          if (antwort.status) {
            fehlgeschlagen(antwort.description || antwort.message || 'Das hat leider nicht geklappt.');
            return;
          }
          if (wk) wk.antwortEinsetzen(antwort);
          else window.location = (window.mhsysShop || {}).warenkorbUrl || '/cart';
          document.dispatchEvent(
            new CustomEvent('mhsys:warenkorb-geaendert', { detail: { quelle: 'produktoptionen' } })
          );
        })
        .catch((fehler) => {
          console.error('Produktoptionen:', fehler);
          fehlgeschlagen('Das hat leider nicht geklappt.');
        })
        .finally(() => {
          this.laeuft = false;
          if (knopf) {
            knopf.removeAttribute('aria-disabled');
            knopf.classList.remove('is-laedt');
          }
        });
    }
  }

  const einrichten = () => {
    document.querySelectorAll('[data-mhsys-po]').forEach((box) => {
      if (box.dataset.mhsysPoBereit) return;
      box.dataset.mhsysPoBereit = '1';
      new MhsysProduktoptionenController(box);
    });
  };

  /* Fuer nachgeladene Kaufbereiche (Schnellansicht, Roadmap 3.25): jede Box wird nur einmal
     eingerichtet (data-mhsys-po-bereit), mehrfaches Aufrufen schadet nicht */
  window.mhsysPoEinrichten = einrichten;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
})();
